module.exports = __webpack_public_path__ + "static/media/md-thermometer.da346ce6.svg";